import { render, staticRenderFns } from "./tabSelector.pug?vue&type=template&id=22b47e37&lang=pug&external"
import script from "./tabSelector.js?vue&type=script&lang=js&external"
export * from "./tabSelector.js?vue&type=script&lang=js&external"
import style0 from "./tabSelector.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b47e37')) {
      api.createRecord('22b47e37', component.options)
    } else {
      api.reload('22b47e37', component.options)
    }
    module.hot.accept("./tabSelector.pug?vue&type=template&id=22b47e37&lang=pug&external", function () {
      api.rerender('22b47e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabSelector/index.vue"
export default component.exports